import {
    Hero,
    ProductShowcase,
    Features,
    HowItWorks,
    AppFeatures,
    Testimonials,
    ProductDemo,
    FAQ,
    CTASection
} from './sections';

const HomePage = () => {
    return (
        <div className="relative max-w-7xl mx-auto sm:px-6 lg:px-8">
            <Hero />

            <div className="relative bg-white dark:bg-gray-900 px-8 pt-8 z-20 rounded-t-[40px]">
                <ProductShowcase />
                <Features />
                <HowItWorks />
                <AppFeatures />
                <Testimonials />
            </div>

            <ProductDemo />

            <div className="py-20 bg-white dark:bg-gray-900 relative z-20">
                <FAQ />
                <CTASection />
            </div>
        </div>
    );
};

export default HomePage;